export default class ArchivosAdjuntosContenidosModel {
    public id?: number;
	public archivo?: string;
	public rutaArchivo?: string;
	public nombre?: string;
	public rutaImagenMostrar?: string | ArrayBuffer;
	public archivoCompleto: File;
}